import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { AccountOpeningDraftDTO, DraftAccountDTO } from '../AccountOpening.meta';
import { useRouteParams } from '../hooks/useRouteParams';
import { queryKeys } from './queryKeys';

export const SAVE_DRAFT_ENDPOINT = '/Consumer/ManagedAccounts/SaveAccountOpeningDraft';

interface SaveDraftParams {
  clientId: string;
  id?: string;
  data: DraftAccountDTO;
}

const saveDraft = ({ clientId, id, data }: SaveDraftParams): Promise<AccountOpeningDraftDTO> => {
  return authFetch(SAVE_DRAFT_ENDPOINT, {
    method: 'POST',
    ...httpBodyOptions({ clientId, id, data }, true),
  });
};

export const useSaveDraftMutation = () => {
  const queryClient = useQueryClient();

  const { clientId, draftId } = useRouteParams();

  const queryKey = queryKeys.draftAccount(clientId, draftId);

  return useMutation(saveDraft, {
    onSuccess(data) {
      queryClient.setQueryData<AccountOpeningDraftDTO | undefined>(queryKey, data);
    },
  });
};
